// extracted by mini-css-extract-plugin
export default {"titleWrap":"titleWrap---khky3","title":"title---Txt1T"};